import xs from "xstream"
import isolate from "@cycle/isolate"
import {dissoc} from 'ramda'

import {PAGE, INPUT_CHECK} from '../../../constant'

import {pageViewTempl, input2Prop, createApiReq, createApiResp, createInputCheck, fmtMember} from '../../common'

import {view} from './view'

const passwordCheck = createInputCheck(INPUT_CHECK['password'])
const newPasswordCheck = createInputCheck(INPUT_CHECK['newPassword'])
const checkPasswordCheck = createInputCheck(INPUT_CHECK['checkPassword'])
const passwordReq = createApiReq("password");
const passwordResp = createApiResp("password");

/* IMPURE TERM CHECK */
const Password = sources => {
  const memberId$ = sources.state.select(["user", "id"]).map(fmtMember)

	const passwordInput$ = sources.DOM.select("#password").events('input').map(input2Prop('password')).remember()
	const newPasswordInput$ = sources.DOM.select("#newPassword").events('input').map(input2Prop('newPassword')).remember()
	const checkPasswordInput$ = sources.DOM.select("#checkPassword").events('input').map(input2Prop('checkPassword'))

	const form$ = xs.merge(passwordInput$, newPasswordInput$, checkPasswordInput$)
		.fold((acc, cur) => {
			return Object.assign(acc, cur)
		}, {password:'', newPassword:'', checkPassword:''})

	const passwordCheck$ = passwordCheck(passwordInput$)
	const newPasswordCheck$ = newPasswordCheck(newPasswordInput$)
	const checkPasswordCheck$ = xs.combine(newPasswordInput$, checkPasswordInput$)
		.map(([{newPassword}, {checkPassword}]:[any,any]) => {
			let check = false
			if (newPassword && newPassword === checkPassword) {
				check = true
			}
			return Object.assign({}, {varName:"checkPassword" , value: checkPassword, message: INPUT_CHECK['checkPassword'].message, check});
		})
	const errorCheck$ = xs.merge(passwordCheck$, newPasswordCheck$, checkPasswordCheck$) 
		.fold((acc, {message, check, varName}: any) => {
			if (!check) {
				return Object.assign({}, acc, {[varName]: message}) 
			} else {
				return dissoc(varName, acc)
			}
		},{});

	const passwordReq$ = sources.DOM.select("#btnUpdate").events("click")
		.map(() => xs.combine(memberId$, passwordInput$, newPasswordInput$)
			.map(([memberId, password, newPassword]) => passwordReq(Object.assign({memberId}, password, newPassword)))
			.take(1)
		)
		.flatten()

	const passwordResp$ = sources.HTTP.select("password")
		.map(resp$ => resp$.replaceError(() => xs.of({body: {message:"通信エラー", status: -5}})))
		.flatten()
		.map(({body}) => {
      return body.message
        ? body.message
        : body.data.message ? body.data.message : "通信エラー"
    });

	const msg$ = xs.merge(passwordResp$).startWith(null)

	const isBusy$ = xs.merge(passwordReq$.mapTo(true), passwordResp$.mapTo(false))

	const btnReturn$ = sources.DOM.select("#btnReturn").events("click").mapTo({type: "goBack"}); 
	const view$ = view(form$, msg$, errorCheck$)
	const pageView = pageViewTempl(PAGE.Password.id)
	return {
		DOM: pageView(view$),
		HTTP: passwordReq$,
		loading: isBusy$,
		router: xs.merge(btnReturn$),
    dumper: memberId$,
	}
}
export default sources => isolate(Password)(sources)
